var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 21 20",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m14.7426 5.75736c-2.3431-2.34315-6.14209-2.34315-8.48524 0s-2.34315 6.14214 0 8.48524c2.03659 2.0366 5.17514 2.3038 7.49964.7982.4635-.3003 1.0827-.1679 1.3829.2956.3003.4636.1679 1.0827-.2956 1.383-3.0998 2.0079-7.2837 1.6549-10.00115-1.0625-3.1242-3.1242-3.1242-8.18956 0-11.31375 3.12419-3.1242 8.18955-3.1242 11.31375 0 1.5618 1.56188 2.3431 3.61105 2.3431 5.65685 0 1.6569-1.3431 3-3 3-.6753 0-1.2985-.2231-1.7999-.5997-.7298.9714-1.8916 1.5997-3.2001 1.5997-2.20914 0-4-1.7909-4-4 0-2.20914 1.79086-4 4-4 2.2091 0 4 1.79086 4 4 0 .5523.4477 1 1 1s1-.4477 1-1c0-1.53706-.5856-3.0709-1.7574-4.24264zm-2.2426 4.24264c0-1.10457-.8954-2-2-2-1.10457 0-2 .89543-2 2 0 1.1046.89543 2 2 2 1.1046 0 2-.8954 2-2z",
    fill: "#8c99ad",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtSymbol);
export default __webpack_public_path__ + "static/media/at-symbol.2bad2578c77a71ef70f3e5631f427b97.svg";
export { ForwardRef as ReactComponent };